import React, { Component } from "react";
// import SearchFilter from "./SearchFilter";
import SearchBox from "components/SearchBox";
// import SearchBox from "../../components/SearchBox/index";

class SearchModal extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }
  render = () => {
    return (
      <div
        className="modal fade"
        id="searchModalComponent"
        style={{ top: "25%" }}
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header py-2 border-0">
              <div className="col-12">
                <div className="row">
                  <div className="col-9">
                    <h4 className="modal-title">Search Results</h4>
                  </div>
                  <div className="col-3">
                    <div className="row">
                      <div className="d-flex align-items-center justify-content-end col-6">
                        <h5 className="mb-0 pl-2" />
                      </div>
                      <div className="d-flex align-items-center col-6 justify-content-end">
                        <button
                          type="button"
                          className="close"
                          data-dismiss="modal"
                        >
                          <h6 className="input-for-search">&times;</h6>
                          <h4 className="pl-1 modal-title">Close</h4>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-body">
              <div className="d-flex">
                <div className="col-8">
                  <SearchBox
                    onChange={(text) => {
                      this.props.onChangeText(text);
                    }}
                    value={this.props.searchText}
                    onKeyPress={(e) => {
                      if (e.key === "Enter") {
                        this.props.searchDevices();
                      }
                    }}
                    onButtonClick={() => {
                      this.props.searchDevices();
                    }}
                  />{" "}
                </div>
                <div className="col-4 d-flex justify-content-end align-items-center">
                  {/* <label htmlFor="selectAll" className="mr-2">
                    Select All
                  </label>
                  <input
                    checked={selectAll}
                    onChange={(e) => {
                      this.props.selectAll(e.target.checked);
                    }}
                    type="checkbox"
                    id="selectAll"
                    name="selectAll"
                    value="selectAll"
                  /> */}
                </div>
              </div>
              <div
                className="slimScrollDiv"
                style={{
                  position: "relative",
                  overflow: "overlay",
                  width: "auto",
                  height: "100%",
                }}
              >
                <div className="inner-height">
                  {this.props.data.length > 0 ? (
                    <table className="table search-table mt-3 table-bordered">
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Select device</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.props.data.length > 0 &&
                          this.props.data.map((item, index) => {
                            const filter = this.props.selected;
                            const isExist = filter.findIndex(
                              (data) => data === item
                            );
                            const selected = isExist !== -1;
                            return (
                              <tr key={index}>
                                <td>{item}</td>
                                <td>
                                  <input
                                    onChange={() => {
                                      this.props.selectDevice(item);
                                    }}
                                    checked={selected}
                                    type="checkbox"
                                    id=""
                                    name=""
                                    value=""
                                  />
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  ) : (
                    <h3>No results to display</h3>
                  )}
                </div>
              </div>
              {this.state.showMoreDevices}
            </div>
          </div>
        </div>
      </div>
    );
  };
}

export default SearchModal;



// WEBPACK FOOTER //
// ./app/routes/configuration/searchModal.js